import { wrapCreateBrowserRouterV6 } from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';

/**
 * Creates a browser router with Sentry integration.
 */
export const createBrowserRouterWithSentry =
  wrapCreateBrowserRouterV6(createBrowserRouter);
